import React from 'react';
import PropTypes from 'prop-types';
import compose from '../hoc/compose';
import displayNames from '../controls/displayNames';
import Button from '../controls/button/button';
import { ChevronLeft as PanelBackButtonCE } from '@wix/wix-ui-icons-common/classic-editor/system';
import { ChevronLeft as PanelBackButtonRE } from '@wix/wix-ui-icons-common/responsive-editor/system';
import { WixBaseUiEnvironmentContext } from '../util/WixBaseUiEnvironment/WixBaseUiEnvironment';
var HeaderBackButton = function HeaderBackButton(_ref) {
  var automationId = _ref.automationId,
    dataHook = _ref.dataHook,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Button, {
    automationId: automationId,
    dataHook: dataHook,
    className: "btn-header-back btn-header btn-back",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(WixBaseUiEnvironmentContext.Consumer, null, function (value) {
    return (value === null || value === void 0 ? void 0 : value.theme) === 'responsive' ? /*#__PURE__*/React.createElement(PanelBackButtonRE, null) : /*#__PURE__*/React.createElement(PanelBackButtonCE, null);
  }));
};
HeaderBackButton.displayName = displayNames.HEADER_BACK_BUTTON;
HeaderBackButton.propTypes = {
  onClick: PropTypes.func
};
export default compose(HeaderBackButton);